// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Uf7t","selects":"Documents_selects__3A-dg"};